import { Box } from "@mui/material";
import { ProcessStarted } from "components";
import { useSelectedOrganization } from "hooks";
import React from "react";

/**
 * Pagina **Operazioni** (`/dashboard/processes` e `/dashboard/process-history`):
 * processi vivi o cronologia.
 *
 * Le viste Monitor SLA e Diagramma SLA (prima tab di questa pagina, rotte
 * `processes/sla` e `processes/sla-diagram`) sono state rimosse: i conteggi SLA
 * (in tempo / a rischio / violati / totale) sono chip nell'intestazione della
 * lista dei processi vivi (`SlaLiveKpiChips`, montato da `ProcessStarted`), e
 * le vecchie rotte reindirizzano qui (`src/App.tsx`).
 */
interface ProcessesProps {
  history?: boolean;
}

const Processes: React.FC<ProcessesProps> = ({ history = false }) => {
  const organization = useSelectedOrganization();

  if (!organization?.id) return null;

  return (
    <Box height="100%" bgcolor="background.default">
      <ProcessStarted
        organization={organization}
        history={history}
        key={history ? "processes-history" : "processes-current"}
      />
    </Box>
  );
};

export default Processes;
